const ATTRS_LABEL = {
  name: '姓名',
  contact: '联系人',
  gender: '性别',
  age: '年龄',
  tel: '电话',
  qq: 'QQ',
  weixin: '微信',
  weibo: '微博',
  address: '地址',
  email: '邮箱',
  comment: '备注'
};

export default { ATTRS_LABEL };
